module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-5.1461a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-5.jpg
// module id = TBF2
// module chunks = 0